import React from "react";
import "./TodoList.css";

export default function TodoList() {
  const todos = [
    "envoyer CV",
    "faire de la musique",
    "ranger bureau"
  ];

  return (
    <div className="todo-container">
      <div className="todo-title">à faire</div>
      <ul className="todo-list">
        {todos.map((todo, index) => (
          <li key={index}>{todo}</li>
        ))}
      </ul>
    </div>
  );
}
